import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'

import { exists } from '~/utils'

export const useAuthorization = () => {
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0()

  const getAuthorization = React.useCallback(async () => {
    let claims = await getIdTokenClaims()
    const now = new Date().getTime() / 1000
    const exp = claims?.exp
    if (!exists(exp) || exp < now + 30) {
      await getAccessTokenSilently()
      claims = await getIdTokenClaims()
    }

    return exists(claims) ? `Bearer ${claims.__raw}` : ''
  }, [getAccessTokenSilently, getIdTokenClaims])

  return getAuthorization
}
